import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=967beea2&scoped=true"
import script from "./VersionInfo.vue?vue&type=script&lang=js"
export * from "./VersionInfo.vue?vue&type=script&lang=js"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&id=967beea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967beea2",
  null
  
)

export default component.exports